import './_jquery';

// Component highlight forced inheritance of its parent flex column
// Dal momento in cui .columns non esiste, deduco che questa roba
// si possa buttare via
// $(window).on('load', function() {
//   $('.component-highlight').parents('.columns').each(function() {
//     let height;

//     if (!$('.component-highlight', this).parent('post__sidebar__element')) {
//       height = $('.component-highlight', this).first().height();
//       $('.component-highlight', this).height(height);
//     }
//   });
// });

$(window).on('resize', function() {
  let newHeight;

  // 1100px is the static width of wrap; 768px is the BEMO 'tab' breakpoint
  if (($('.wrap').width() < parseInt($('.wrap').css('max-width'))) && ($(window).width() > 768)) {
    newHeight = ($('.wrap').width()) / 3;

    $('.component_gridbox').each(function() {
      $(this).height(newHeight);
    });

    $('.component_gridbox--last').each(function() {
      $(this).height(newHeight);
    });
  }
}).trigger('resize');

/* =============================================================== */
// post prev/next button height
jQuery(function() {
  let borderHeight, buttonHeight, buttonHeightNext, buttonHeightPrev, forceResizeComponentVideoYouTubeIframes, isEdge, propertyNext, propertyPrev, proportionalConst, style, windowWidth;

  if ($('.post__content__related-post').length > 0) {
    windowWidth = window.screen.width;
    proportionalConst = 3;

    if (windowWidth > 768) { proportionalConst = 2.5; }
    if (windowWidth > 860) { proportionalConst = 2.4; }
    if (windowWidth > 1024) { proportionalConst = 2.3; }

    if ($('.post__content__related-post__prev').length > 0) {
      buttonHeightPrev = $('.post__content__related-post__prev').height();
    } else {
      buttonHeightPrev = 0;
    }

    if ($('.post__content__related-post__next').length > 0) {
      buttonHeightNext = $('.post__content__related-post__next').height();
    } else {
      buttonHeightNext = 0;
    }

    buttonHeight = Math.max(buttonHeightPrev, buttonHeightNext);
    $('.post__content__related-post__prev').height(buttonHeight);
    $('.post__content__related-post__next').height(buttonHeight);

    borderHeight = Math.sqrt(Math.pow(buttonHeight, 2) + Math.pow(buttonHeight, 2)) / proportionalConst / 15 + "rem";
    propertyPrev = "border-width: " + borderHeight + " 2rem " + borderHeight + " 0";
    propertyNext = "border-width: " + borderHeight + " 0 " + borderHeight + " 2rem";

    style = document.createElement("style");
    document.head.appendChild(style);
    style.sheet.insertRule(".post__content__related-post__prev::before { " + propertyPrev + " }", 0);
    style.sheet.insertRule(".post__content__related-post__next::before { " + propertyNext + " }", 0);
  }

  window.forceResizeComponentVideoYouTubeIframes = forceResizeComponentVideoYouTubeIframes = function() {
    $("[data-iframe='youtube-video']").each(function(i, el) {
      let $currentEl, $iframe, videoHeight, videoWidth;
      $currentEl = $(el);
      $iframe = $(el);
      videoWidth = $iframe.outerWidth();
      videoHeight = (videoWidth / 16) * 9;
      $currentEl.removeClass('force-iframe-height');
      $currentEl.height(videoHeight);
      $iframe.height(videoHeight);
    });
  };

  forceResizeComponentVideoYouTubeIframes();

  // img vertical alignment fix -  Microsoft Edge
  isEdge = window.navigator.userAgent.indexOf('Edge/') > 0 ? true : false;

  if (isEdge) {
    $('.v-align--center').each(function() {
      if (!$(this).closest('.tab-full')) {
        $(this).addClass('v-align--center--absolute');
      }

      $(this).removeClass('v-align--center');
    });
  }
});
